import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import cn from 'clsx';
import { TextComponent } from '../../uiComponents';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import templateGeneratorOptions from './templateGeneratorOptions';
// import { sendAIAnalyticsTrace } from '../utils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import BadgeComponent from '../jsonComponents/badgeComponent';
const styles1: any = makeStyles((theme: Theme) =>
  createStyles({
    alignItems: {
      alignItems: 'flex-start',
    },
    baseAlign: {
      alignItems: 'baseline',
    },
    centerAlign: {
      alignItems: 'center',
    },
    justifyCentre: {
      justifyContent: 'center',
      marginTop: 20,
    },
    submitButton: {
      marginLeft: 20,
    },
    divider: {
      borderBottom: '1px solid #cecece',
      margin: 0,
      flex: 1,
    },
    templatesList: {
      width: '100%',
    },
    mt50: {
      marginTop: 50,
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    heading: {
      fontSize: '1.2rem',
      lineHeight: 1.5,
      fontWeight: 500,
    },
    options: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '50px',
    },
    subOptions: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginLeft: '100px',
    },
    // option:{
    //     display: 'flex',
    //     flexDirection: 'row',
    // }
  }),
);
interface TemplateOptionsProps {
  handleClose: any;
}

const TemplateOptions = ({ handleClose }: TemplateOptionsProps) => {
  const classes: any = jsonEditorStyles();
  const classes1 = styles1();
  /* 
    plaRank 
    1 - free
    2 - paid
  */
  const planRank: number = 1;
  const [options, setOptions] = useState<any>(templateGeneratorOptions);
  return (
    <>
      <div className={cn(classes.flexCol)}>
        <div className={cn(classes1.heading)}>Sign In Option</div>
        <div className={cn(classes1.options)}>
          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Enable MFA"
              control={
                <Checkbox
                  checked={options.mfa.value}
                  disabled={planRank < options.mfa.showToPlanType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      mfa: { ...options.mfa, value: !options.mfa.value },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.mfa.showToPlanType} />
          </div>
        </div>
        <div className={cn(classes1.heading)}>Bio Metric Login</div>
        <div className={cn(classes1.options)}>
          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Enable Biometric"
              control={
                <Checkbox
                  checked={options.biometric.value}
                  disabled={planRank < options.biometric.showToPlanType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      biometric: { ...options.biometric, value: !options.biometric.value },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.biometric.showToPlanType} />
          </div>
        </div>
        <div className={classes1.divider}></div>
        <div className={cn(classes1.heading)}>Conditional Access</div>
        <div className={cn(classes1.options)}>
          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Enable Conditional Access"
              control={
                <Checkbox
                  checked={options.conditionalAccess.value}
                  disabled={planRank < options.conditionalAccess.showToPlanType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      conditionalAccess: { ...options.conditionalAccess, value: !options.conditionalAccess.value },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.mfa.showToPlanType} />
          </div>
        </div>
        <div className={cn(classes1.heading)}>Password migration (select any one option)</div>
        <div className={cn(classes1.options)}>
          <FormControlLabel
            sx={{ m: 0 }}
            label="Migrate passwords without the user having to reset to a new password."
            control={
              <Checkbox
                checked={options.passwordMigration.selectedOption === 'migratePasswords'}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setOptions({
                    ...options,
                    passwordMigration: {
                      ...options.passwordMigration,
                      selectedOption:
                        options.passwordMigration.selectedOption !== 'migratePasswords' ? 'migratePasswords' : '',
                      migratePasswords: {
                        ...options.passwordMigration.migratePasswords,
                      },
                    },
                  });
                }}
              />
            }
          />
        </div>
        {options.passwordMigration.selectedOption === 'migratePasswords' && (
          <div className={cn(classes1.subOptions)}>
            <FormControl>
              <RadioGroup
                row
                value={options.passwordMigration.migratePasswords.migrateOption}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setOptions({
                    ...options,
                    passwordMigration: {
                      ...options.passwordMigration,
                      migratePasswords: {
                        ...options.passwordMigration.migratePasswords,
                        migrateOption: e.target.value,
                      },
                    },
                  });
                }}
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <div className={cn(classes.flexRow, classes1.centerAlign)}>
                  <FormControlLabel
                    value="sha256"
                    disabled={planRank < options.passwordMigration.migratePasswords.sha256.showToPlanType}
                    control={<Radio />}
                    label="SHA 256"
                  />
                  <BadgeComponent
                    rank={planRank}
                    showToPlanType={options.passwordMigration.migratePasswords.sha256.showToPlanType}
                  />
                </div>

                <div className={cn(classes.flexRow, classes1.centerAlign)}>
                  <FormControlLabel
                    value="sha1"
                    disabled={planRank < options.passwordMigration.migratePasswords.sha1.showToPlanType}
                    control={<Radio />}
                    label="SHA 1"
                  />
                  <BadgeComponent
                    rank={planRank}
                    showToPlanType={options.passwordMigration.migratePasswords.sha1.showToPlanType}
                  />
                </div>

                <div className={cn(classes.flexRow, classes1.centerAlign)}>
                  <FormControlLabel
                    value="customHashingEncryptionAlgo"
                    disabled={
                      planRank < options.passwordMigration.migratePasswords.customHashingEncryptionAlgo.showToPlanType
                    }
                    control={<Radio />}
                    label="Custom Hashing Encryption Algorithm"
                  />
                  <BadgeComponent
                    rank={planRank}
                    showToPlanType={
                      options.passwordMigration.migratePasswords.customHashingEncryptionAlgo.showToPlanType
                    }
                  />
                </div>
              </RadioGroup>
            </FormControl>
          </div>
        )}
        <div className={cn(classes1.options)}>
          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Reset password"
              control={
                <Checkbox
                  checked={options.passwordMigration.selectedOption === 'resetPassword'}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      passwordMigration: {
                        ...options.passwordMigration,
                        selectedOption:
                          options.passwordMigration.selectedOption !== 'resetPassword' ? 'resetPassword' : '',
                      },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.passwordMigration.resetPassword.showToPlanType} />
          </div>
        </div>
        <div className={classes1.divider}></div>
        <div className={cn(classes1.heading)}>Enable otp login</div>
        <div className={cn(classes1.options)}>
          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Email OTP"
              control={
                <Checkbox
                  checked={options.otp.emailOTP.value}
                  disabled={planRank < options.otp.emailOTP.showToPlanType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      otp: {
                        ...options.otp,
                        emailOTP: { ...options.otp.emailOTP, value: !options.otp.emailOTP.value },
                      },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.otp.emailOTP.showToPlanType} />
          </div>

          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Choice between email and phone"
              control={
                <Checkbox
                  checked={options.otp.choiceBetweenEmailPhone.value}
                  disabled={planRank < options.otp.choiceBetweenEmailPhone.showToPlanType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      otp: {
                        ...options.otp,
                        choiceBetweenEmailPhone: {
                          ...options.otp.choiceBetweenEmailPhone,
                          value: !options.otp.choiceBetweenEmailPhone.value,
                        },
                      },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.otp.choiceBetweenEmailPhone.showToPlanType} />
          </div>
        </div>
        <div className={classes1.divider}></div>
        <div className={cn(classes1.heading)}>Sign Up</div>
        <div className={cn(classes1.options)}>
          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Attributes to Collect"
              control={
                <Checkbox
                  checked={options.signUp.attributesToCollect.value}
                  disabled={planRank < options.signUp.attributesToCollect.showToPlanType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      signUp: {
                        ...options.signUp,
                        attributesToCollect: {
                          ...options.signUp.attributesToCollect,
                          value: !options.signUp.attributesToCollect.value,
                        },
                      },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.signUp.attributesToCollect.showToPlanType} />
          </div>

          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Collect MFA"
              control={
                <Checkbox
                  checked={options.signUp.collectMFA.value}
                  disabled={planRank < options.signUp.collectMFA.showToPlanType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      signUp: {
                        ...options.signUp,
                        collectMFA: {
                          ...options.signUp.collectMFA,
                          value: !options.signUp.collectMFA.value,
                        },
                      },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.signUp.collectMFA.showToPlanType} />
          </div>

          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Send welcome emails"
              control={
                <Checkbox
                  checked={options.signUp.sendWelcomeEmails.value}
                  disabled={planRank < options.signUp.sendWelcomeEmails.showToPlanType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      signUp: {
                        ...options.signUp,
                        sendWelcomeEmails: {
                          ...options.signUp.sendWelcomeEmails,
                          value: !options.signUp.sendWelcomeEmails.value,
                        },
                      },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.signUp.sendWelcomeEmails.showToPlanType} />
          </div>

          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Call triggers - Salesforce API integration "
              control={
                <Checkbox
                  checked={options.signUp.salesForceAPI.value}
                  disabled={planRank < options.signUp.salesForceAPI.showToPlanType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      signUp: {
                        ...options.signUp,
                        salesForceAPI: {
                          ...options.signUp.salesForceAPI,
                          value: !options.signUp.salesForceAPI.value,
                        },
                      },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.signUp.salesForceAPI.showToPlanType} />
          </div>

          <div className={cn(classes.flexRow, classes1.centerAlign)}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Identity Proofing - Add Generic provider"
              control={
                <Checkbox
                  checked={options.signUp.addGenericProvider.value}
                  disabled={planRank < options.signUp.addGenericProvider.showToPlanType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setOptions({
                      ...options,
                      signUp: {
                        ...options.signUp,
                        addGenericProvider: {
                          ...options.signUp.addGenericProvider,
                          value: !options.signUp.addGenericProvider.value,
                        },
                      },
                    });
                  }}
                />
              }
            />
            <BadgeComponent rank={planRank} showToPlanType={options.signUp.addGenericProvider.showToPlanType} />
          </div>
        </div>
        <div className={classes1.divider}></div>
        <div className={cn(classes1.heading)}>Password Expiry</div>
        <div className={cn(classes1.options)}>
          <div className={cn(classes.flexRow, classes1.baseAlign)}>
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setOptions({
                  ...options,
                  enablePasswordExpiry: {
                    ...options.enablePasswordExpiry,
                    numberOfDays: {
                      ...options.enablePasswordExpiry.numberOfDays,
                      value: e.target.value,
                    },
                  },
                });
              }}
              data={{
                style: { margin: 1, width: 200 },
                value: options.enablePasswordExpiry.numberOfDays.value,
                disabled: planRank < options.enablePasswordExpiry.numberOfDays.showToPlanType,
                helperText: 'Enabled in paid plan',
                label: 'Number of days',
              }}
            />
            <BadgeComponent rank={planRank} showToPlanType={options.enablePasswordExpiry.numberOfDays.showToPlanType} />
          </div>
        </div>
        <div className={classes1.divider}></div>
        <div className={cn(classes1.heading)}>Social Providers</div>
        <div className={cn(classes1.options)}>
          {Object.keys(options.social).map((prop: string) => (
            <div className={cn(classes.flexRow, classes1.centerAlign)} key={prop}>
              <FormControlLabel
                sx={{ m: 0 }}
                label={options.social[prop]['displayName']}
                control={
                  <Checkbox
                    checked={options.social[prop].value}
                    disabled={planRank < options.social[prop].showToPlanType}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setOptions({
                        ...options,
                        social: {
                          ...options.social,
                          [prop]: { ...options.social[prop], value: !options.social[prop].value },
                        },
                      });
                    }}
                  />
                }
              />
              <BadgeComponent rank={planRank} showToPlanType={options.social[prop].showToPlanType} />
              {options.social[prop].value && (
                <FormControlLabel
                  sx={{ m: 0 }}
                  label="Link Accounts"
                  control={
                    <Checkbox
                      checked={options.social[prop].linkAccounts}
                      disabled={planRank < options.social[prop].showToPlanType}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setOptions({
                          ...options,
                          social: {
                            ...options.social,
                            [prop]: { ...options.social[prop], linkAccounts: !options.social[prop].linkAccounts },
                          },
                        });
                      }}
                    />
                  }
                />
              )}
            </div>
          ))}
        </div>
      </div>
      <footer className={cn(classes.footer, classes1.mt50)}>
        <Button
          variant="contained"
          color="primary"
          // disabled={existingFCNames.length === 0}
          onClick={() => {
            handleClose(options);
          }}
        >
          Generate Template
        </Button>
      </footer>
    </>
  );
};

// export default withAITracking(reactPlugin, PromptEmail);
export default TemplateOptions;
